import React from 'react';
import PropTypes from 'prop-types';

import style from './index.scss';

const FilterList = (props) => {
  const { filter, checkboxStates, onCheckboxChange } = props;

  if (!filter) {
    return null;
  }

  let subList = [];
  if (filter) {
    filter.group.forEach((item, i) => {
      const isChecked = checkboxStates ? checkboxStates[item.name] : true;
      subList.push(
        <li className="checkbox-item-filter" key={i}>
          <div className="custom-checkbox">
            <input
              type="checkbox"
              className="css-checkbox"
              name={item.name}
              id={item.name}
              checked={isChecked}
              onChange={(e) => {
                onCheckboxChange(filter.name, item.name);
              }}
            />
            <label className="css-label" htmlFor={item.name}>
              {item.value}
            </label>
          </div>
        </li>
      );
    });
  }

  return (
    <div className={style.filterList}>
      <ul className="list-unstyled">
        <li>
          <div className="custom-checkbox">
            <input
              type="checkbox"
              id={filter.id}
              name={filter.name}
              className="css-gray-checkbox css-checkbox parent-checkbox"
              checked="checked"
              disabled=""
              readOnly={true}
            />
            <label htmlFor={filter.name} className="css-label">
              {filter.value}
            </label>
          </div>
        </li>
        {subList}
      </ul>
    </div>
  );
};

FilterList.propTypes = {
  filter: PropTypes.object.isRequired,
  checkboxStates: PropTypes.object,
  onCheckboxChange: PropTypes.func
};

export default FilterList;
